import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./starbucks_order_type.js";
//#region src/starbucks_order_type_helper.ts
var starbucks_order_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(orderType) {
	switch (orderType) {
		case "in-store": return "In-Store";
		case "drive-thru": return "Drive-Thru";
		case "curbside": return "Curbside";
		case "outdoor": return "Outdoor";
	}
}
//#endregion
export { name, starbucks_order_type_helper_exports };

//# sourceMappingURL=starbucks_order_type_helper.js.map